// @flow
import React, { Component } from "react";
import { Link } from "react-router-dom";

const envanteriumLogoTextOnly = require("../../Assets/Logo/envanterium-logo-text-only-light.png");

type PropsType = {
  translate: string => void,
  setActiveLanguage: string => void
};

type StateType = {};

class Navbar extends Component<PropsType, StateType> {
  render() {
    const { translate, setActiveLanguage } = this.props;

    return (
      <div>
        {/* --- TOP PART OF NAVBAR --- */}
        <section className="topbar d-lg-flex text-white bg-transparent">
          <div className="container small-3">
            <nav className="nav">
              <Link to="/hakkimizda" className="nav-link pl-0">
                {translate("NavbarLocale.menu_item.about")}
              </Link>
              <Link to="/iletisim" className="nav-link">
                {translate("NavbarLocale.menu_item.contact")}
              </Link>
            </nav>
            <nav className="nav align-right">
              <div className="mr-4">
                <div className="d-flex align-items-center">
                  <a
                    href={`${process.env.REACT_APP_DASHBOARD_BASE_API_URL}/kayit-ol`}
                    className="btn btn-xs btn-link text-white ml-lg-5 mr-2"
                  >
                    {translate("NavbarLocale.menu_item.register")}
                  </a>
                  <a
                    href={`${process.env.REACT_APP_DASHBOARD_BASE_API_URL}/giris`}
                    className="btn btn-xs btn-success"
                  >
                    {translate("NavbarLocale.menu_item.login")}
                  </a>
                </div>
              </div>
              <div className="dropdown mr-4">
                <span
                  className="btn btn-xs btn-link text-white"
                  data-toggle="dropdown"
                >
                  {translate("NavbarLocale.language")}{" "}
                  <i className="fas fa-caret-down" />
                </span>
                <div className="dropdown-menu dropdown-menu-right">
                  <a
                    className="dropdown-item cursor-pointer"
                    onClick={() => {
                      setActiveLanguage("tr");
                    }}
                  >
                    {translate("NavbarLocale.language_dropdown.turkish")}
                  </a>
                  <a
                    className="dropdown-item cursor-pointer"
                    onClick={() => {
                      setActiveLanguage("en");
                    }}
                  >
                    {translate("NavbarLocale.language_dropdown.english")}
                  </a>
                </div>
              </div>
            </nav>
          </div>
        </section>

        {/* --- BOTTOM PART OF NAVBAR --- */}
        <nav
          className="navbar navbar-expand-lg navbar-light"
          data-navbar="static"
        >
          <div className="container">
            <div className="navbar-left">
              <button className="navbar-toggler" type="button">
                &#9776;
              </button>
              <Link to="/" className="navbar-brand">
                <img
                  className="envanterium-navbar-logo"
                  src={envanteriumLogoTextOnly}
                  alt="logo"
                />
              </Link>
            </div>

            <section className="navbar-mobile">
              <nav className="nav nav-navbar ml-auto">
                <Link to="/envanter-sayim" className="nav-link">
                  {translate("NavbarLocale.menu_item.processing")}
                </Link>
                <Link to="/ik-cozumleri" className="nav-link">
                  {translate("NavbarLocale.menu_item.hrsolutions")}
                </Link>
              </nav>
            </section>
          </div>
        </nav>
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/Components/Navbar/Navbar.js